import type { EventType } from '../types';

export const EVENT_TYPE_OPTIONS: EventType[] = [
  'SHOW',
  'BDAY',
  'FESTIVAL',
  'ANNOUNCEMENT',
];
